// extracted by mini-css-extract-plugin
export var notificationHost = "_ln-0";